<template>
  <div class="dialog-wrap">
    <el-dialog
      title="账号管理"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="678px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
      >
        <el-form-item
          label="账号名称"
          prop="name"
        >
          <el-input
            v-model="dataForm.name"
            placeholder="请输入账号名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="类型"
          prop="type_code"
        >
          <el-select
            v-model="dataForm.type_code"
            placeholder="请选择类型"
            style="width:360px;"
          >
            <el-option
              label="机构"
              :value="1"
            ></el-option>
            <el-option
              label="课程"
              :value="2"
            ></el-option>
            <el-option
              label="学科"
              :value="3"
            ></el-option>
            <el-option
              label="院校"
              :value="4"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="院校学科"
          prop="college"
        >
          <el-select
            v-model="dataForm.college"
            placeholder="请输入院校"
            filterable
            clearable
            value-key="code"
            @change="collegeChange"
            style="width:360px;"
          >
            <el-option
              v-for="(item,index) in $store.state.collegeList"
              :key="index"
              :label="item.name"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-input
            :value="dataForm.major"
            placeholder="选择专业"
            suffix-icon="el-icon-search"
            style="width:360px;margin-top:16px;"
            @focus="handleMajorChoose"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="所属平台"
          prop="platform_code"
        >
          <el-select
            v-model="dataForm.platform_code"
            placeholder="请选择所属平台"
            style="width:360px;"
          >
            <el-option
              label="小红书"
              :value="1"
            ></el-option>
            <el-option
              label="公众号"
              :value="2"
            ></el-option>
            <el-option
              label="微博"
              :value="3"
            ></el-option>
            <!--         <el-option
              label="B站"
              :value="4"
            ></el-option> -->
            <el-option
              label="知乎"
              :value="5"
            ></el-option>
            <!--       <el-option
              label="抖音"
              :value="6"
            ></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item
          label="每日要求"
          prop="daily_require_count"
        >
          <el-input-number v-model="dataForm.daily_require_count"></el-input-number>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="dataForm.remark"
            type="textarea"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
    <MajorChoose
      :visible="majorChooseDialog"
      :majors="majors"
      @close="majorChooseDialog = false"
      @submit="saveMajor"
      :single="true"
    ></MajorChoose>
  </div>
</template>

<script>

import { collegeMajorList } from "@/api/common";
import MajorChoose from "@/components/dialog/major/MajorChoose";
import { mediaaccountUpdate } from "@/api/select";
export default {
  components: {
    MajorChoose
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => {
        return null
      }
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: this.content,
      rules: {
        name: [{ required: true, message: '请输入账号名称', trigger: 'blur' }],
        major: [{ required: true, message: '请选择专业', trigger: 'change' }],
        platform_code: [{ required: true, message: '请选择所属平台', trigger: 'change' }],
        daily_require_count: [{ required: true, message: '请输入每日要求数量', trigger: 'change' }],
        type_code: [{ required: true, message: '请选择类型', trigger: 'change' }],

        /*       college: [{
                required: true,
                validator: (rule, value, callback) => {
                  if (!this.dataForm.major && !this.dataForm.college) {
                    callback(new Error('请选择院校学科'))
                  } else {
                    callback()
                  }
                },
              }] */
      },
      majorList: [],
      majorChooseDialog: false,
      majors: [],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      if (val) {
        this.dataForm = val

        if (val.college_code) {
          this.$set(this.dataForm, 'college', {
            name: this.dataForm.college_name,
            code: this.dataForm.college_code,
          })
        }
        if (val.major_code) {
          let obj = {
            name: val.major_name,
            code: val.major_code
          }
          this.majors.push(obj)
          this.dataForm.major = `(${val.major_code})${val.major_name}`
        }
        this.$forceUpdate()
      }
    }
  },
  methods: {
    handleMajorChoose() {
      this.majorChooseDialog = true;
    },
    saveMajor({ majors }) {
      this.majors = majors;
      this.dataForm.major = `(${this.majors[0].code})${this.majors[0].name}`
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let query = {
            id: this.dataForm.id,
            name: this.dataForm.name,
            type_code: this.dataForm.type_code,
            platform_code: this.dataForm.platform_code,
            college_code: this.dataForm.college ? this.dataForm.college.code : "",
            college_name: this.dataForm.college ? this.dataForm.college.name : "",
            major_code: this.majors.length ? this.majors[0].code : "",
            major_name: this.majors.length ? this.majors[0].name : "",
            daily_require_count: this.dataForm.daily_require_count,
            remark: this.dataForm.remark,
          }
          mediaaccountUpdate(query).then(res => {
            this.$message.success(`创建成功`)
            this.$refs['dataForm'].resetFields()
            this.$emit('submit')
            this.handleClose()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    handleClose() {
      this.$emit('close')
    },
    collegeChange(e) {
      this.getMajor(e.code)
    },
    getMajor(college_code) {
      collegeMajorList({
        college_code: college_code,
        isPaging: 0,
      }).then((res) => {
        this.majorList = res.list || [];
      });
    },
  }
}
</script>

<style lang="less" scoped>
</style>
